(function($) {

	'use strict';

	var init = function() {
		initPopupListeners();
    };
    
    var initPopupListeners = function() {
		$('[data-popup]:not([data-popup=""]').on('click', openPopup);
		$('.popup-box__close').on('click', closePopup);
	}
	
	var openPopup = function(){
		var id = $(this).data('popup');
		var popup = $('.popup-box#'+id);
		if( popup && !popup.hasClass('active') ){
			popup.addClass('active');
		}
	}

	var closePopup = function(){
		var item = $(this);
		var popup = item.closest('.popup-box');
		if( popup.hasClass('active') ){
			popup.removeClass('active');
		}
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);